import { z } from 'zod';

export function AttachmentSchema() {
	return z.object({
		id: z.string(),
		name: z.string(),
		size: z.number(),
		mimeType: z.string(),
		previewUrl: z.string(),
		status: z.enum(['uploading', 'success', 'error']),
		progress: z.number(),
		error: z.string().optional(),
		remoteId: z.string().optional()
	});
}
